import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import moment from "moment-timezone"
import * as React from "react"
import { Col, Layout, Row } from "antd"
import * as FontSize from "../../constants/fontSizes"
import { getMainColor } from "../../utils/environment"
import { Config } from "../../utils/config"
import * as Color from "../../constants/colors"
import { AutoCloseMessageComponent } from "../common/components/AutoCloseMessage/AutoCloseMessageComponent"

type Props = {
    children: React.ReactNode
    autoCloseMessage?: Maybe<any>
}

const UnauthorizedLayout = ({ autoCloseMessage = null, children }: Props) => {
    return (
        <Layout>
            <style jsx={true} global={true}>
                {`
                    .login-logo {
                        font-weight: 700;
                        color: white;
                        padding-left: 1rem;
                        font-size: ${FontSize.lg};
                    }
                `}
            </style>
            {/* @ts-expect-error */}
            <AutoCloseMessageComponent
                text={autoCloseMessage ? autoCloseMessage.text : null}
                type={autoCloseMessage ? autoCloseMessage.type : null}
            />
            <Layout.Header
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: getMainColor(Config.environment),
                    borderBottom: "3px #ccced0 solid",
                    height: 55,
                    padding: 0,
                }}>
                <span className="login-logo">Figure Manage</span>
            </Layout.Header>

            <Layout.Content>
                <Row className={classes.contentWrap}>
                    <Col xl={8} xxl={6} md={10} xs={24}>
                        {children}
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "1.5rem",
                                color: Color.Grey,
                            }}>
                            Copyright © {moment().format("YYYY")} - Figure
                        </div>
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    )
}

const classes = {
    contentWrap: "flex w-full justify-center px-2 pb-12 md:px-20",
}

export default UnauthorizedLayout
